// @flow

export const dataKey: 'vendingDishesEditList' = 'vendingDishesEditList';
